module.exports = __webpack_public_path__ + "img/license_image12.e4c9ad9f.png";